import { createContext, useContext } from 'react'

import { Form } from '../stores/formStore'

const storesContext = createContext({
    formStore: new Form()
});

const useStores = () => useContext(storesContext);

export default useStores;
